/**
 * `official.ts`（v3.16）—— MeshLink 官方号与官方公告（内容冷启动）。
 *
 * 官方号 DID 固定；公告为平台级静态内容（后续可服务端化/链上化）。
 * 关注官方号上链（socialAct follow）并联动新手任务「关注官方号」。
 */
import { markTaskDone } from '@/utils/tasks';

/** 官方号地址（固定，占位 DID 已注册于链：meshlink.xyz 保留地址）。 */
export const OFFICIAL_ADDRESS = '0x0000000000000000000000000000000000000001' as `0x${string}`;
export const OFFICIAL_DID = `did:dpb:${OFFICIAL_ADDRESS}`;
export const OFFICIAL_NAME = 'MeshLink 官方';

export interface OfficialAnnouncement {
  icon: string;
  title: string;
  body: string;
  ts: string;
}

/** 官方公告（内容冷启动：新用户进入发现页即有内容可看可关注）。 */
export const OFFICIAL_ANNOUNCEMENTS: OfficialAnnouncement[] = [
  {
    icon: '📣',
    title: '欢迎来到 MeshLink',
    body: '去中心化即时通讯 + DP 链生态一体：聊天端到端加密、内容上链进推荐流、身份即钱包。你的 12 个助记词就是全部资产。',
    ts: '2026-10-04',
  },
  {
    icon: '⛏️',
    title: '全行为挖矿',
    body: '不按时间出 DPB，按行为出 DPB：发文、点赞、收藏、分享、浏览、完播、签到、搜索……行为上链即自动增发奖励，无需领取。',
    ts: '2026-10-04',
  },
  {
    icon: '🎁',
    title: '邀请好友有奖励',
    body: '通过专属链接邀请好友创建身份并绑定，双方各得 0.002 DPB 推荐奖励；好友后续消费核销时，你享 8% 推广佣金。',
    ts: '2026-10-04',
  },
  {
    icon: '💬',
    title: '群聊已上线',
    body: '建群、邀请好友入群、群消息端到端加密分发。后续开放群邀请链接与满员奖励，敬请期待。',
    ts: '2026-10-04',
  },
];

/** 标记「关注官方号」任务完成。 */
export function markOfficialFollowed(): void {
  markTaskDone('followedOfficial');
}
